/*
 * Pong 404 — Level 2 Alpine component
 *
 * Mounted on the 404 error page. On init, rewrites the pong overlay's intro
 * copy and exit button to be 404-appropriate, then activates the pong store
 * so the overlay (rendered in the base layout) appears automatically.
 *
 * On teardown (Swup navigation away), the intro copy and exit are restored to
 * their defaults so the easter-egg experience is unaffected elsewhere.
 */
export default function pong404() {
    return {
        init() {
            const store = this.$store.pong;
            store.setIntroCopy('Page not found', "Fancy a game while you're here?");
            store.setExit('Take me home', '/');
            store.open();
        },

        destroy() {
            const store = this.$store.pong;
            store.close();
            store.setIntroCopy('Controls', '');
            store.setExit('Exit', '');
        },
    };
}
